var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvalonia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:1;}\n\t.st2{fill:#5D2F75;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#8B44AC;}\n"))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,32c0,1.7-1.1,3.2-2.7,3.6c-0.4,0.1-0.7,0.2-1.1,0.2c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 c0.4,0,0.8,0.1,1.1,0.2C13.1,28.8,14.2,30.3,14.2,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,31.7v20.9H42v-2.4c-1.6,0.9-3.3,1.5-5.1,2c-0.8,0.2-1.7,0.4-2.6,0.5c-0.8,0.1-1.5,0.1-2.3,0.1 c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.5,0c-9.1-0.4-16.8-6.8-19.1-15.4c2.4-0.7,4.1-2.8,4.1-5.4c0-2.6-1.7-4.7-4.1-5.4 c2.4-8.9,10.5-15.4,20.1-15.4c11,0,20.1,8.6,20.7,19.5c0,0.1,0,0.3,0,0.5c0,0.1,0,0.3,0,0.5C52.8,31.6,52.8,31.7,52.8,31.7 L52.8,31.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,31.7v20.9h-5.4V31.2h5.4c0,0.1,0,0.3,0,0.5C52.8,31.6,52.8,31.7,52.8,31.7L52.8,31.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,52.7c-0.8,0.1-1.5,0.1-2.3,0.1c-0.2,0-0.4,0-0.6,0v-0.1H34.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,48.8v3.9h-4c0.1-0.2,0.1-0.3,0.2-0.5C49.9,50.7,51.2,49.5,52.8,48.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,35.6c-0.4,0.1-0.7,0.2-1.1,0.2c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0.4,0,0.8,0.1,1.1,0.2 c1.6,0.5,2.7,1.9,2.7,3.6C14.2,33.7,13.1,35.2,11.5,35.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,31.7v20.9H42v-2.4c-1.6,0.9-3.3,1.5-5.1,2c-0.8,0.2-1.7,0.4-2.6,0.5c-0.8,0.1-1.5,0.1-2.3,0.1 c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.5,0c-9.1-0.4-16.8-6.8-19.1-15.4c2.4-0.7,4.1-2.8,4.1-5.4c0-2.6-1.7-4.7-4.1-5.4 c2.4-8.9,10.5-15.4,20.1-15.4c11,0,20.1,8.6,20.7,19.5c0,0.1,0,0.3,0,0.5c0,0.1,0,0.3,0,0.5C52.8,31.6,52.8,31.7,52.8,31.7 L52.8,31.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,31.7v20.9h-5.4V31.2h5.4c0,0.1,0,0.3,0,0.5C52.8,31.6,52.8,31.7,52.8,31.7L52.8,31.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,52.7c-0.8,0.1-1.5,0.1-2.3,0.1c-0.2,0-0.4,0-0.6,0v-0.1H34.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.1,32v-0.4h0C63.1,31.7,63.1,31.9,63.1,32z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 64 30.7 C 63.7 22.6 60.4 15.1 54.7 9.3 C 48.6 3.3 40.5 0 32 0 C 23.5 0 15.4 3.3 9.4 9.4 C 3.3 15.4 0 23.5 0 32 C 0 40.5 3.3 48.6 9.4 54.6 C 15.2 60.4 22.8 63.7 31 64 L 55.9 64 C 59.9 64 63.2 61 63.9 57.2 L 64 57.2 L 64 30.7 Z",
    style: {
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.8,48.8v3.9h-4c0.1-0.2,0.1-0.3,0.2-0.5C49.9,50.7,51.2,49.5,52.8,48.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -67.5118,
    y1: 339.7588,
    x2: -54.128,
    y2: 353.1426,
    gradientTransform: "matrix(1.8122 0 0 -1.8122 142.2195 659.8314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#623079"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    style: {
      stopColor: "#8B44AC"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.5,28.4c-0.2,1.2-0.3,2.4-0.3,3.6c0,1.2,0.1,2.5,0.3,3.6c1.6-0.5,2.7-1.9,2.7-3.6 C14.2,30.3,13.1,28.8,11.5,28.4z M52.8,31.7c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0-0.5C52.1,19.8,43,11.2,32,11.2 c-9.6,0-17.7,6.5-20.1,15.4c2.4,0.7,4.1,2.8,4.1,5.4c0,2.6-1.7,4.7-4.1,5.4c2.3,8.5,9.9,14.9,19.1,15.4c0.2,0,0.3,0,0.5,0 c0.2,0,0.4,0,0.6,0c0.8,0,1.5,0,2.3-0.1c0.9-0.1,1.7-0.2,2.6-0.5c1.8-0.4,3.5-1.1,5.1-2c1.8-1,3.5-2.3,4.9-3.8 c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.3-0.3,0.5-0.5c3.1-3.6,5-8.3,5-13.5C52.8,31.9,52.8,31.8,52.8,31.7z M32,42 c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C42,37.5,37.5,42,32,42z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 31.7,
    className: "st4",
    width: 10.8,
    height: 20.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.2,32c0,1.7-1.1,3.2-2.7,3.6c-0.4,0.1-0.7,0.2-1.1,0.2c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 c0.4,0,0.8,0.1,1.1,0.2C13.1,28.8,14.2,30.3,14.2,32z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalonia);
export default __webpack_public_path__ + "static/media/Avalonia.062476fec9a6a162d12c44573d55076a.svg";
export { ForwardRef as ReactComponent };